import { render } from "./FormAccount.vue?vue&type=template&id=4a7dea71&ts=true"
import script from "./FormAccount.vue?vue&type=script&lang=ts"
export * from "./FormAccount.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/web-factory/barsmart/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__